import { render, staticRenderFns } from "./SuggestedItems.vue?vue&type=template&id=d2af3aa0&"
import script from "./SuggestedItems.vue?vue&type=script&lang=js&"
export * from "./SuggestedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports